import { t, Instance } from 'mobx-state-tree';

/**
 * Manages the grandparents of the parents of the tree anchor from HybridPedigreeStore
 */
export const GrandparentsGenerationModel = t
  .model('GrandparentsGeneration', {
    leftGrandparentsLeftFamilyMemberId: t.maybeNull(t.string),
    leftGrandparentsRightFamilyMemberId: t.maybeNull(t.string),
    rightGrandparentsLeftFamilyMemberId: t.maybeNull(t.string),
    rightGrandparentsRightFamilyMemberId: t.maybeNull(t.string)
  })
  .actions((self) => ({
    setLeftGrandparentsLeftFamilyMemberId(leftGrandparentsLeftFamilyMemberId: string | null) {
      self.leftGrandparentsLeftFamilyMemberId = leftGrandparentsLeftFamilyMemberId;
    },

    setLeftGrandparentsRightFamilyMemberId(leftGrandparentsRightFamilyMemberId: string | null) {
      self.leftGrandparentsRightFamilyMemberId = leftGrandparentsRightFamilyMemberId;
    },

    setRightGrandparentsLeftFamilyMemberId(rightGrandparentsLeftFamilyMemberId: string | null) {
      self.rightGrandparentsLeftFamilyMemberId = rightGrandparentsLeftFamilyMemberId;
    },

    setRightGrandparentsRightFamilyMemberId(rightGrandparentsRightFamilyMemberId: string | null) {
      self.rightGrandparentsRightFamilyMemberId = rightGrandparentsRightFamilyMemberId;
    },

    clear() {
      self.leftGrandparentsLeftFamilyMemberId = null;
      self.leftGrandparentsRightFamilyMemberId = null;
      self.rightGrandparentsLeftFamilyMemberId = null;
      self.rightGrandparentsRightFamilyMemberId = null;
    }
  }));

export type GrandparentsGenerationType = Instance<typeof GrandparentsGenerationModel>;
